var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.155 13.984c-1.975 0-4.268-1.118-6.149-3.001C-.018 7.961-.9 4.094 1.002 2.19l.926-.924a1.07 1.07 0 0 1 1.447 0L5.799 3.69a1.046 1.046 0 0 1 0 1.486l-.94.938a.526.526 0 0 0-.059.67q.481.699 1.085 1.292.592.605 1.288 1.09a.53.53 0 0 0 .673-.066l.933-.937a1.08 1.08 0 0 1 1.49 0l2.424 2.423a1.044 1.044 0 0 1 0 1.479l-.919.923a3.62 3.62 0 0 1-2.619.996M2.645 2.03l-.869.923C.33 4.397 1.263 7.708 3.773 10.226c1.657 1.651 3.718 2.676 5.382 2.676a2.57 2.57 0 0 0 1.881-.678l.919-.924-2.416-2.373-.89.938a1.615 1.615 0 0 1-2.04.195 9.4 9.4 0 0 1-1.447-1.22 10 10 0 0 1-1.223-1.442 1.61 1.61 0 0 1 .196-2.034l.94-.938z"
  })));
};
export default SvgCall;